
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import axios from 'axios';
import sha1 from 'sha1';

import {
  CognitoUser,
  AuthenticationDetails
} from 'amazon-cognito-identity-js';

import { getLogo, getTitle } from '../../brand';

import Auth from '../../utils/Auth';
import { getBackendBaseUrl } from '../../constants';

import { updateUserProfile, fetchUserProfile, fetchTranslations } from './redux/actions';
import { fetchChangePin } from '../../components/topbar/profile/redux/actions';

import LoginForm from './components/LoginForm';
import ForceChangePasswordForm from './components/ForceChangePasswordForm';

import windowPlane from './icons/Window-1.svg';
import windowSky from './icons/Window-2.svg';

import styles from './authentication.module.scss';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import ChangeForgotPasswordForm from './components/ChangeForgotPasswordForm';
import ProfileEdit from '../../components/topbar/profile/View/ProfileEdit';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 'login',
      newPassword: '',
      confirmPassword: '',
      newPin: '',
      confirmPin: '',
      verificationCode: '',
      passwordMatches: true,
      pinMatches: true,
      errors: {
        emailEmpty: true,
        verificationCodeEmpty: false,
        newPasswordEmpty: true,
        confirmPasswordEmpty: true,
        passwordEmpty: true,
        newPinEmpty: true,
        confirmPinEmpty: true,
        newPinLength: true,
        confirmPinLength: true,
        invalidCredentials: false,
        invalidPassword: false,
        emailInvalid: false,
        InvalidPin: false,
        LimitExcced: false,
        verificationInvalid: false
      },
      blurredFields: {
        email: false,
        password: false,
        newPassword: false,
        confirmPassword: false,
        newPin: false,
        confirmPin: false
      }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSignIn = this.handleSignIn.bind(this);
    this.handleForcedPasswordChange = this.handleForcedPasswordChange.bind(this);
    this.handleNewPasswordRequired = this.handleNewPasswordRequired.bind(this);
    this.checkPasswordMatch = this.checkPasswordMatch.bind(this);
    this.checkEmptyFields = this.checkEmptyFields.bind(this);
    this.checkLengthFields = this.checkLengthFields.bind(this);
    this.checkPinMatch = this.checkPinMatch.bind(this);
    this.handleChangePin = this.handleChangePin.bind(this);
    this.validateFormFields = this.validateFormFields.bind(this);
    this.handleInputBlurred = this.handleInputBlurred.bind(this);
    this.handleAuthError = this.handleAuthError.bind(this);
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
    this.handleForgotPasswordForm = this.handleForgotPasswordForm.bind(this);
    this.handleChangeForgotPassword = this.handleChangeForgotPassword.bind(this);
    this.handleChangeForgotPasswordForm = this.handleChangeForgotPasswordForm.bind(this);
    this.handleProfileEdit = this.handleProfileEdit.bind(this);
  }

  // eslint-disable-next-line react/sort-comp
  validateFormFields(inputType, value) {
    let errors = {};
    let emailValid;
    let PinValid;
    switch (inputType) {
      case 'email':
        if (value === '') {
          errors = Object.assign(errors, { emailEmpty: true, emailInvalid: false });
        } else {
          emailValid = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(value);
          errors = Object.assign(errors, { emailEmpty: false, emailInvalid: !emailValid });
        }
        break;
      case 'password':
        errors = Object.assign(errors, { passwordEmpty: value === '' });
        break;
      case 'newPassword':
        if (value === '') {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { newPasswordEmpty: true })
          }));
        } else {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { newPasswordEmpty: true })
          }));
        }
        break;
      case 'confirmPassword':
        if (value === '') {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { confirmPasswordEmpty: true })
          }));
        } else {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { confirmPasswordEmpty: true })
          }));
        }
        break;
      case 'verificationCode':
        errors = Object.assign(errors, { verificationCodeEmpty: value === '' });
        break;
      case 'newPin':
        if (value === '') {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { newPinEmpty: true, newPinLength: true, InvalidPin: false })
          }));
        } else {
          PinValid = /^\d+$/.test(value);
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { newPinLength: true, newPinEmpty: true, InvalidPin: !PinValid })
          }));
        }
        break;
      case 'confirmPin':
        if (value === '') {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { confirmPinEmpty: true, confirmPinLength: true })
          }));
        } else {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { confirmPinLength: true, confirmPinEmpty: true })
          }));
        }
        break;
      default:
        break;
    }
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, errors)
    }));
  }

  handleInputChange(inputType, value) {
    this.setState({
      [inputType]: value
    }, () => this.validateFormFields(inputType, value));
  }

  handleInputBlurred(inputType) {
    this.setState(prevState => ({
      blurredFields: Object.assign({}, prevState.blurredFields, {
        [inputType]: true
      })
    }));
  }

  checkEmptyFields = () => {
    const { newPin, confirmPin, newPassword, confirmPassword } = this.state;
    if (newPin === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          newPinEmpty: false
        })
      }));
    }
    if (confirmPin === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          confirmPinEmpty: false
        })
      }));
    }
    if (newPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          newPasswordEmpty: false
        })
      }));
    }
    if (confirmPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          confirmPasswordEmpty: false
        })
      }));
    }
  }

  checkLengthFields = () => {
    const { newPin, confirmPin } = this.state;
    if (!(newPin.length === 4)) {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          newPinLength: false
        })
      }));
      return;
    }
    if (!(confirmPin.length === 4)) {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          confirmPinLength: false
        })
      }));
    }
  }

  checkPasswordMatch() {
    const { newPassword, confirmPassword } = this.state;

    if (newPassword !== '' && confirmPassword !== '') {
      this.setState({
        passwordMatches: (newPassword === confirmPassword)
      });
    } else {
      this.setState({ passwordMatches: true });
    }
  }

  checkPinMatch() {
    const { newPin, confirmPin } = this.state;

    if (newPin !== '' && confirmPin !== '') {
      this.setState({
        pinMatches: (newPin === confirmPin)
      });
    } else {
      this.setState({ pinMatches: true });
    }
  }

  handleChangePin() {
    const { actionFetchChangePin } = this.props;
    const { newPin } = this.state;
    const oldPin = '0000';
    const data = { oldpin: sha1(oldPin), newpin: sha1(newPin) };
    actionFetchChangePin(data);
  }

  handleForcedPasswordChange(e) {
    const { newPassword, confirmPassword,
      newPin,
      confirmPin,
      cognitoUser,
      passwordMatches,
      pinMatches } = this.state;
    const { actionFetchUserProfile, actionFetchTranslations } = this.props;
    e.preventDefault();

    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, {
        invalidPassword: false
      })
    }));

    this.checkPasswordMatch();
    if (!passwordMatches) {
      return;
    }
    this.checkPinMatch();
    if (!pinMatches) {
      return;
    }
    this.checkEmptyFields();
    if (newPin === '') {
      return;
    }
    this.checkLengthFields();
    if (!(newPin.length === 4)) {
      return;
    }
    if (confirmPin === '') {
      return;
    }
    if (!(newPin.length === 4)) {
      return;
    }
    if (newPassword === '') {
      return;
    }
    if (confirmPassword === '') {
      return;
    }

    cognitoUser.completeNewPasswordChallenge(newPassword, [], {
      onSuccess: (result) => {
        Auth.getInstance().setAuthToken(result.getAccessToken().getJwtToken());
        actionFetchUserProfile();
        actionFetchTranslations();
        this.handleChangePin();
        this.handleProfileEdit();
      },
      onFailure: this.handleAuthError
    });
  }

  handleAuthError(error) {
    switch (error.code) {
      case 'NotAuthorizedException':
      case 'UserNotFoundException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            invalidCredentials: true
          })
        }));
        break;
      case 'CodeMismatchException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            verificationInvalid: true
          })
        }));
        break;
      case 'LimitExceededException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            LimitExcced: true
          })
        }));
        break;
      case 'InvalidPasswordException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            invalidPassword: true
          })
        }));
        break;
      case 'InvalidParameterException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            emailInvalid: true
          })
        }));
        break;
      default:
        break;
    }
  }

  // XXX: Check if necessary
  // handleNewPasswordRequired(userAttributes, requiredAttributes) {
  handleNewPasswordRequired() {
    this.setState({
      currentPage: 'forceChangePassword'
    });
  }

  handleForgotPassword() {
    this.setState(prevState => ({
      blurredFields: Object.assign({}, prevState.blurredFields, {
        email: false
      }),
      errors: Object.assign({}, prevState.errors, {
        emailEmpty: true,
        emailInvalid: false
      }),
      email: '',
      currentPage: 'forgot'
    }));
  }

  handleChangeForgotPassword = () => {
    this.setState({
      currentPage: 'ChangeForgotpassword'
    });
  }

  handleProfileEdit() {
    this.setState({
      currentPage: 'profile'
    });
  }

  handleForgotPasswordForm(e) {
    e.preventDefault();
    const { email, errors } = this.state;
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, {
        invalidCredentials: false, LimitExcced: false
      })
    }));

    if (errors.emailEmpty || errors.emailInvalid) {
      this.setState(prevState => ({
        blurredFields: Object.assign({}, prevState.blurredFields, {
          email: true
        })
      }));
      return;
    }
    const cognitoUser = new CognitoUser({
      Username: email,
      Pool: Auth.getInstance().getUserPool()
    });

    cognitoUser.forgotPassword({
      onSuccess: () => {
        this.handleChangeForgotPassword();
      },
      onFailure: (err) => {
        this.handleAuthError(err);
      }
    });
  }

  handleChangeForgotPasswordForm(e) {
    e.preventDefault();
    const { verificationCode, newPassword, confirmPassword, email } = this.state;

    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, {
        verificationInvalid: false, invalidPassword: false
      })
    }));

    if (verificationCode === '') {
      this.setState(prevState => ({
        errors: Object.assign({},
          prevState.errors,
          { verificationCodeEmpty: true })
      }));
      return;
    }
    if (newPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({},
          prevState.errors,
          { newPasswordEmpty: true })
      }));
      return;
    }
    if (confirmPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({},
          prevState.errors,
          { confirmPasswordEmpty: true })
      }));
      return;
    }
    const cognitoUser = new CognitoUser({
      Username: email,
      Pool: Auth.getInstance().getUserPool()
    });
    cognitoUser.confirmPassword(verificationCode, newPassword,
      {
        onSuccess: () => {
          this.setState({ currentPage: 'login' });
        },
        onFailure: (err) => {
          this.handleAuthError(err);
        }
      });
  }

  handlePath() {
    const { match: { url }, history } = this.props;
    if (url === '/auth/login') {
      history.push('/');
      window.location.reload();
    } else {
      window.location.reload();
    }
  }

  handleSignIn(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, {
        invalidCredentials: false
      })
    }));
    const { email, password, errors, newPassword, currentPage } = this.state;
    if (errors.emailEmpty || errors.emailInvalid || errors.passwordEmpty) {
      this.setState(prevState => ({
        blurredFields: Object.assign({}, prevState.blurredFields, {
          email: true,
          password: true
        })
      }));
      return;
    }

    const authDetails = new AuthenticationDetails({
      Username: email,
      Password: currentPage === 'profile' ? newPassword : password
    });

    const cognitoUser = new CognitoUser({
      Username: email,
      Pool: Auth.getInstance().getUserPool()
    });

    this.setState({ cognitoUser });

    const {
      storeUserProfile,
      actionFetchUserProfile,
      actionFetchTranslations } = this.props;

    storeUserProfile(cognitoUser);
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: (result) => {
        Auth.getInstance().setAuthToken(result.getAccessToken().getJwtToken());
        Auth.getInstance().setIDToken(result.getIdToken().getJwtToken());
        let token = result.getIdToken().getJwtToken().split('.')[1];
        token = Buffer.from(token, 'base64').toString();
        // eslint-disable-next-line no-undef
        localStorage.setItem('userId', JSON.parse(token)['cognito:username']);
        axios.defaults.baseURL = getBackendBaseUrl();
        actionFetchUserProfile();
        actionFetchTranslations();
        this.handlePath();
      },
      onFailure: this.handleAuthError,
      newPasswordRequired: this.handleNewPasswordRequired
    });
  }

  render() {
    const { currentPage, passwordMatches, pinMatches, errors, blurredFields, email } = this.state;
    const { match: { url } } = this.props;
    let formToRender;
    if (currentPage === 'login') {
      formToRender = (
        <LoginForm
          handleInputChange={this.handleInputChange}
          handleSignIn={this.handleSignIn}
          errors={errors}
          url={url}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          handleForgotPassword={this.handleForgotPassword}
        />
      );
    } else if (currentPage === 'forceChangePassword') {
      formToRender = (
        <ForceChangePasswordForm
          handleInputChange={this.handleInputChange}
          handleForcedPasswordChange={this.handleForcedPasswordChange}
          checkPasswordMatch={this.checkPasswordMatch}
          checkEmptyFields={this.checkEmptyFields}
          checkLengthFields={this.checkLengthFields}
          newPasswordEmpty={errors.newPasswordEmpty}
          confirmPasswordEmpty={errors.confirmPasswordEmpty}
          checkPinMatch={this.checkPinMatch}
          pinMatches={pinMatches}
          newPinEmpty={errors.newPinEmpty}
          confirmPinEmpty={errors.confirmPinEmpty}
          newPinLength={errors.newPinLength}
          confirmPinLength={errors.confirmPinLength}
          passwordMatches={passwordMatches}
          InvalidPin={errors.InvalidPin}
          invalidPassword={errors.invalidPassword}
        />
      );
    } else if (currentPage === 'forgot') {
      formToRender = (
        <ForgotPasswordForm
          handleInputChange={this.handleInputChange}
          errors={errors}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          email={email}
          handleForgotPasswordForm={this.handleForgotPasswordForm}
        />
      );
    } else if (currentPage === 'ChangeForgotpassword') {
      formToRender = (
        <ChangeForgotPasswordForm
          handleInputChange={this.handleInputChange}
          handleChangeForgotPasswordForm={this.handleChangeForgotPasswordForm}
          errors={errors}
        />
      );
    } else if (currentPage === 'profile') {
      formToRender = (
        <ProfileEdit
          currentPage={currentPage}
          handleSignIn={this.handleSignIn}
        />
      );
    }
    return (
      url === '/auth/login' ? (
        <div className={styles.authentication}>
          <div className={styles.logo_container} style={{ flexDirection: 'row' }}>
            <img src={getLogo()} alt="logo" style={{ maxWidth: '80px' }} />
            <div className={styles.brand} style={{ fontSize: '48px', letterSpacing: '1px' }}>{getTitle()}</div>
          </div>
          <div className={styles.form_container}>
            <img src={windowSky} className={styles.window_sky} alt="window_sky" />
            {formToRender}
            <img src={windowPlane} className={styles.window_plane} alt="window_plane" />
          </div>
        </div>) : <> {formToRender} </>
    );
  }
}

Login.propTypes = {
  // Dispatch redux functions
  storeUserProfile: PropTypes.func.isRequired,
  match: PropTypes.shape({}).isRequired,
  actionFetchUserProfile: PropTypes.func.isRequired,
  actionFetchTranslations: PropTypes.func.isRequired,
  actionFetchChangePin: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = dispatch => ({
  // Update profile
  storeUserProfile: (profile) => {
    dispatch(updateUserProfile(profile));
  },
  actionFetchChangePin: (data) => {
    dispatch(fetchChangePin(data));
  },
  actionFetchUserProfile: () => {
    dispatch(fetchUserProfile());
  },
  actionFetchTranslations: () => {
    dispatch(fetchTranslations());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Login));
